import { GridController, gridTpl } from '../../../../../common/grid/grid.controller';
import { IDS } from '../../settings-action-id.constants';
import * as Actions from '../slo-required-docs.actions';
import {GRID_FILTER_TOGGLE} from "../../../../../common/grid/grid.constants";

class SloRequiredDocsImportsGridController extends GridController {
    constructor($ngRedux, $state, $stateParams, NavigationService, AuthService, $filter, $mdDialog, $scope) {
        super($ngRedux, $state, NavigationService, $filter, $mdDialog);
        this.$stateParams = $stateParams;
        this.$scope = $scope;
        this.AuthService = AuthService;
    }

    $onInit() {
        this.module = 'accreditation';
        this.identifier = IDS.accSettings;
        this.statePath = IDS.sloRequiredDocsImportsGrid;
        this.filterOpen = true;
        this.filterExpandButtonVisible = false;
        this.exportComponent = false;
        this.confirmDialogOnRemove = true;
        // this.autoload = false;
        this.icon = false;

        this.$ngRedux.dispatch({
            type: GRID_FILTER_TOGGLE,
            id: IDS.accSettings,
            path: IDS.sloRequiredDocsImportsGrid,
            filter: {
                scheme_code: this.$stateParams.itemCode
            }
        });

        this.isAdmin = this.AuthService.getUser().type === 'Administrator';

        this.columnsDefault = [
            {title: '#',                                                            mapper: null},
            {title: this.$filter('translate')(`COMMON.FIELD.CREATED`),              mapper: 'started'},
            {title: this.$filter('translate')(`COMMON.FIELD.HEAD_OFFICE`),          mapper: 'location'},
            {title: this.$filter('translate')(`COMMON.FIELD.AUTHOR`),               mapper: 'issuer'},
        ];
        this.columns = this.columnsDefault.concat();

        this.unsubscribe = this.$ngRedux.connect(this.mapState().bind(this), Actions)(this);

        this.dataAction = this.fetchSloRequiredDocsImportsGrid;

        this.buttons.push({
            class: 'btnGridAction',
            label: 'Download',
            callback: event => {
                this.onDownload(event);
            },
            filter: item => {
                return item.import_file_uri
            },
        });
        this.init();
    }

    $onDestroy() {
        this.destroy();
    }
}

SloRequiredDocsImportsGridController.$inject = ['$ngRedux', '$state', '$stateParams', 'NavigationService', 'AuthService', '$filter', '$mdDialog', '$scope'];

export const sloRequiredDocsImportsGrid = {
    bindings: {
        onSelect: '&',
        onDownload: '&',
    },
    controller: SloRequiredDocsImportsGridController,
    ...gridTpl
}
